import PostJobSteps from "./_components/PostJobSteps";

const Page = () => {
  return (
    <>
      <div className="p-6">
        <div className="flex justify-center ">
          <PostJobSteps />
        </div>
      </div>
    </>
  );
};

export default Page;
